import { css } from '@emotion/react';
import styled from '@emotion/styled';

// Components
import Icon from './oc-icon';
import ImageShareLinks from './oc-image-share-links';
import Picture from './oc-picture';
import WrapperLink from './oc-wrapper-link';
import Theme from '../../themes/index';

const Media = styled.div`
  margin-bottom: 8px;
  position: relative;

  img {
    display: block;
    max-width: 100%;
    width: 100%;
  }
`;

const IconWrapper = styled.div`
  align-items: center;
  background: white;
  bottom: 0;
  color: ${Theme.colors.brand};
  display: flex;
  font-size: 21px;
  height: 42px;
  justify-content: center;
  left: 0;
  position: absolute;
  width: 42px;
`;

const Card = ({
  img,
  alt,
  url,
  icon,
  analytics,
  children,
  aspectRatio,
  // eslint-disable-next-line react/prop-types
  linkText,
  transform = 'cards',
  socialShare,
  ctaSwitch,
  handleCtaButtonClick,
  ...props
}) => {
  if (aspectRatio) {
    aspectRatio.custom = aspectRatio.custom?.toString();
  }

  const getAriaLabel = () => {
    if (alt) {
      return alt;
    }
    if (linkText) {
      return linkText;
    }

    return 'Learn More';
  };

  return (
    <div {...props}>
      <WrapperLink url={url} aria-label={getAriaLabel()} tabIndex="-1" analytics={analytics}>
        {img && (
          <Media>
            {icon && (
              <IconWrapper>
                <Icon type={icon} />
              </IconWrapper>
            )}

            <Picture
              source={img}
              transform={transform}
              aspectRatio={aspectRatio}
              alt={alt}
              {...(!!ctaSwitch && { onClick: handleCtaButtonClick })}
            />

            {socialShare && <ImageShareLinks imageUrl={img} />}
          </Media>
        )}
      </WrapperLink>

      <div>{children}</div>
    </div>
  );
};

export default Card;
